import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import { getUserProfile, saveUserProfile } from '../../api/user';
import { countries } from '../../constants/countries';
import PaymentButton from './paymentButton';
import { useNotification } from '../../contexts/notification';

const OrderInvoiceData = ({ itemData, handleCallback }) => {
  const [invoicePartner, setInvoicePartner] = useState({});
  const [companyData, setCompanyData] = useState(false);
  const { setNotification } = useNotification();
  const isFormValid = () => {
    const requiredFields = [
      'firstName',
      'lastName',
      'email',
      'country',
      'zip',
      'city',
      'street',
    ];

    return requiredFields.every(
      (field) => invoicePartner[field] && invoicePartner[field].trim() !== ''
    );
  };

  useEffect(() => {
    getUserProfile()
      .then((data) => {
        const profile = data.Profile;
        setInvoicePartner({
          ...profile,
          paymentMethod: '',
        });
        setCompanyData(profile.taxInvoice);
      })
      .catch((error) => console.error(error));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    setInvoicePartner((prev) => ({ ...prev, [name]: newValue }));
    if (name === 'taxInvoice') {
      setCompanyData(newValue);
    }
  };

  const handleSubmit = (paymentMethod) => {
    if (!isFormValid()) {
      setNotification({
        open: true,
        message:
          'Kérlek tölts ki minden adatot a számlázáshoz és a fizetéshez!',
        severity: 'error',
      });
      return;
    }

    const updatedData = { ...invoicePartner, paymentMethod };
    setInvoicePartner(updatedData);
    saveUserProfile(updatedData);
    handleCallback(updatedData);
  };

  return (
    <Box className='InvoiceData' sx={{ mt: 2 }}>
      <Typography variant='h5' textAlign='center' mb={2}>
        Számlázási adatok
      </Typography>

      <Box sx={{ backgroundColor: 'background.paper', p: 2, borderRadius: 2 }}>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField
              label='Vezetéknév'
              name='lastName'
              value={invoicePartner.lastName || ''}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField
              label='Keresztnév'
              name='firstName'
              value={invoicePartner.firstName || ''}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField
              label='E-Mail cím'
              name='email'
              value={invoicePartner.email || ''}
              enabled={false}
              fullWidth
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField
              label='Telefonszám 1'
              name='phone1'
              value={invoicePartner.phone1 || ''}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth>
              <InputLabel>Ország</InputLabel>
              <Select
                label='Ország'
                name='country'
                value={invoicePartner.country || ''}
                onChange={handleChange}
              >
                {countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item size={{ xs: 4, sm: 2, md: 2 }}>
            <TextField
              label='Irányítószám'
              name='zip'
              value={invoicePartner.zip || ''}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item size={{ xs: 8, sm: 4, md: 3 }}>
            <TextField
              label='Város'
              name='city'
              value={invoicePartner.city || ''}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
            <TextField
              label='Cím'
              name='street'
              value={invoicePartner.street || ''}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>

      <Box
        className='payment-methods'
        mt={3}
        display='flex'
        flexWrap='wrap'
        justifyContent='center'
        gap={2}
      >
        <PaymentButton
          text='Bankkártyás fizetés indítása'
          type='BANK_CARD'
          onPaymentButtonClick={handleSubmit}
        />
      </Box>
    </Box>
  );
};

export default OrderInvoiceData;
